@if (isLoading()) {
  <div class="fm-loader-overlay" aria-live="polite" aria-label="Loading" role="status">
    <div class="fm-loader-box">
      <div class="fm-loader-ring-inner"></div>
      <img class="fm-loader-logo" src="images/logo-icon.svg" alt="Forever Memories" />
    </div>
  </div>
}
